export default __webpack_public_path__ + "static/media/sheet_thumb06_budgetplanner2@2x.dc6cd583.png";